module.exports = __webpack_public_path__ + "static/media/galeno.a1c88d12.jfif";